import axios from "axios";

const api = axios.create({
  baseURL: "http://localhost:8083",
});

const addUser = (post) => api.post("/api/adduser", post);
const checkEmail = (queryParams) => api.get(`/api/checkemail?${queryParams}`);

export { addUser, checkEmail };
